import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { MlmProgramCCEndpointLinkContainerModel,} from '../../../../../../models/aggregates/erp/mlm-admin';


@Injectable({ providedIn: 'root' })
export class MlmProgramCCEndpointLinkService extends BaseApiTemplateService<MlmProgramCCEndpointLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/mlm-program-cc-ep-link';
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mlm/mlm-program-cc-ep-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'mlm/mlm-program-cc-ep-link';
    this.httpClient = theHttp;
  }


}

